<template>
  <div class="personManagement">
    <el-row>
      <el-form
        :inline="true"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        @submit.native.prevent
      >
        <el-form-item label="人员类别" prop="typeName">
          <el-input
            v-model.trim="typeName"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
          <!-- <el-autocomplete
                v-model.trim="typeName"
                auto-complete="off"
                placeholder=""
                style="width:100%"
                :fetch-suggestions="querySearchAsync"
                @select="handleOlderSelect"
                @keyup.enter.native.prevent="enterSearchMember"
              ></el-autocomplete> -->
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            plain
            @click="queryTable"
          >
            查询</el-button
          >
          <el-button
            type="warning"
            plain
            class="el-icon-plus"
            @click="addPersonManager"
          >
            新建类别</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-table
        :data="tableData"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
        style="width: 100%"
      >
        <el-table-column
          prop="userTypeName"
          label="人员类别"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="remark"
          label="类别说明"
          align="center"
        ></el-table-column>
        <el-table-column prop="option" label="操作" align="center">
          <template slot-scope="scope">
           
            <el-button
              style="margin-right: 5px"
              type="primary"
              size="mini"
              plain
              @click="fixtable(scope.row)"
              >编辑</el-button
            >
            <el-button
              style="margin-right: 5px"
              type="danger"
              size="mini"
              plain
              @click="deletPersonManager(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <!-- 新建人员类别弹窗 -->
    <el-dialog
      :title="isAdd ? '新建人员类别' : '修改人员类别'"
      :visible.sync="personDialogVisible"
      width="25%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeDialog"
    >
      <el-form
        :model="addPersonType"
        :rules="addRules"
        ref="addPersonType"
        label-width="100px"
      >
        <el-form-item label="人员类别" prop="userTypeName">
          <el-input
            v-model.trim="addPersonType.userTypeName"
            type="text"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="类别说明" prop="remark">
          <el-input
            v-model.trim="addPersonType.remark"
            type="textarea"
            style="width: 200px"
            :autosize="{ minRows: 2, maxRows: 6 }"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="personDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="formEnter">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "personManagement",
  data() {
    return {
      typeName: "", //查询input框类别名
      tableData: [], //表格数据
      addPersonType: {
        userTypeName: "",
        remark: "",
        id: "",
      }, //添加表单数据
      personDialogVisible: false, //弹窗默认关闭
      isAdd: true, //控制弹窗的标题
      addRules: {
        userTypeName: [
          { required: true, message: "请输入人员类别", trigger: "blur" },
          { min: 1, max: 20, message: "长度不能超过20个字符" },
        ],
        remark: [{ min: 0, max: 300, message: "输入长度不能超过300个字符" }],
      },
    };
  },
  mounted() {
    this.findTable();
  },
  methods: {
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    /* 
      enter查询
    */
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.typeName != null) {
        if (this.typeName == "") {
          this.findTable(this.typeName);
        } else {
          this.findTable(this.typeName);
        }
      }
    },
    /* 
      新增人员类别
    */
    addPersonManager() {
      this.personDialogVisible = true;
      this.isAdd = true;
    },

    /* 
      模糊查询人员类别
    */
    querySearchAsync(queryString, cb) {
      var list = [{}];
      if (this.tableData) {
        for (let i of this.tableData) {
          i.value = i.userTypeName; //将想要展示的数据作为value
        }
        list = this.tableData;
        cb(list);
      } else {
        let arr = [];
        arr.push({
          uuid: "-1",
          value: "",
        });
        cb(arr);
        setTimeout(() => {
          this.userTypeName = "";
        }, 1000);
      }
    },
    /* 
      模糊查询获取name
    */
    handleOlderSelect(val) {
      this.typeName = val;
    },
    /* 
      查询按钮
    */
    queryTable() {
      this.findTable();
    },
    /* 
        查询表格数据
      */
    findTable() {
      let param = {
        pageNum: 0,
        pageSize: 0,
        userTypeName: this.typeName,
      };
      this.$postJson("omc/userType/queryListWithPage", param).then((res) => {
        this.tableData = res.result.list;
      });
    },

    /* 
      修改表格数据
    */
    fixtable(row) {
      this.personDialogVisible = true;
      this.isAdd = false;
      //数据回显
      this.$nextTick(() => {
        this.addPersonType = {
          userTypeName: row.userTypeName,
          remark: row.remark,
          id: row.id,
        };
      });
    },

    /* 
      表单确认按钮
    */
    formEnter() {
      if (this.isAdd) {
        //添加人员类别
        this.$refs["addPersonType"].validate((valid) => {
          //校验条件
          if (valid) {
            let param = {
              userTypeName: this.addPersonType.userTypeName,
              remark: this.addPersonType.remark,
              userTypeCode: this.addPersonType.userTypeName,
            };
            this.$postJson("omc/userType/save", param).then((res) => {
              if (res.code == 200) {
                this.$message({ message: res.message, type: "success" });
                this.personDialogVisible = false; //关闭弹窗
                this.findTable();
              } else {
                this.$message({ message: res.message, type: "error" });
              }
            });
          } else {
            return false;
          }
        });
      } else {
        //修改人员类别
        this.$refs["addPersonType"].validate((valid) => {
          if (valid) {
            let param = {
              id: this.addPersonType.id,
              userTypeName: this.addPersonType.userTypeName,
              remark: this.addPersonType.remark,
            };
            this.$postJson("omc/userType/edit", param).then((res) => {
              if (res.code == 200) {
                this.$message({ message: res.message, type: "success" });
                this.personDialogVisible = false; //关闭弹窗
                this.findTable();
              } else {
                this.$message({ message: res.message, type: "error" });
              }
            });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },

    /* 
      删除按钮
    */
    deletPersonManager(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        center:true
      })
        .then(() => {
          this.$postForm("omc/userType/deleteById", { id: row.id }).then(
            (res) => {
              if (res.code == 200) {
                this.$message({ message: res.message, type: "success" });
                this.findTable();
              } else {
                this.$message({ message: res.message, type: "error" });
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    /* 
      关闭弹窗
    */
    closeDialog() {
      this.$nextTick(() => {
        if (this.$refs["addPersonType"]) {
          this.$refs["addPersonType"].resetFields(); //清空添加数据
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.curcor {
  cursor: pointer;
  margin-left: 5px;
  margin-right: 5px;
}
//  ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
</style>